<template>
  <section
    class="campaign-area"
    :dir="uiLocale === 'en' ? 'ltr' : 'rtl'"
  >
    <div class="campaign-panel">
      <h2>{{ words.settingTitle }}</h2><p>{{ words.settingIntro }}</p>
      <div class="campaign-grid">
        <label>{{ words.selectionMode }}<select
          :aria-label="words.selectionMode"
          :value="settings.mode"
          @change="change({ mode: $event.target.value })"
        ><option value="automatic">{{ words.automaticSelection }}</option><option value="manual">{{ words.manual }}</option><option value="disabled">{{ words.disabled }}</option></select></label>
        <label v-if="settings.mode !== 'disabled'">{{ words.position }}<select
          :aria-label="words.position"
          :value="settings.placementMode"
          @change="change({ placementMode: $event.target.value })"
        ><option value="inherit">{{ words.inherit }}</option><option
          v-if="!endOnly"
          value="automatic"
        >{{ words.automatic }}</option><option value="end">{{ words.endPosition }}</option></select></label>
      </div>
      <template v-if="settings.mode === 'manual'">
        <p>{{ words.manualHint }}</p><label>{{ words.search }}<input
          v-model="search"
          maxlength="100"
          @keydown.enter.prevent="load"
        ></label><button
          type="button"
          :disabled="loading"
          @click="load"
        >
          {{ words.pick }}
        </button>
        <label>{{ words.choose }}<select
          :value="settings.campaignId || ''"
          @change="change({ campaignId: $event.target.value })"
        ><option value="">{{ words.choose }}</option><option
          v-if="missing"
          :value="settings.campaignId"
        >{{ words.unavailable }}</option><option
          v-for="item in options"
          :key="item.id"
          :value="item.id"
        >{{ item.title }}</option></select></label>
      </template>
      <p
        v-if="message"
        role="status"
      >
        {{ message }}
      </p>
    </div>
  </section>
</template>
<script>
import axios from '@/libs/axios'
import messages from './messages'
import { safeSettings, errorKey } from './model'
import './campaign.css'

export default {
  props: { value: { type: Object, default: () => ({}) }, lang: { type: String, default: 'fa' }, endOnly: Boolean },
  data() {
    return {
      options: [], search: '', loading: false, message: '', sequence: 0,
    }
  },
  computed: {
    uiLocale() { return this.$i18n.locale }, words() { return messages[this.uiLocale] || messages.fa }, settings() { return safeSettings(this.value) }, missing() { return this.settings.campaignId && !this.options.some(item => item.id === this.settings.campaignId) },
  },
  watch: { lang() { this.sequence += 1; this.options = []; this.loading = false; this.message = ''; this.load() } },
  created() { this.load() },
  beforeDestroy() { this.sequence += 1 },
  methods: {
    change(patch) { this.$emit('input', safeSettings({ ...this.settings, ...patch })) },
    async load() {
      this.sequence += 1; const { sequence } = this; this.loading = true; this.message = ''
      try {
        const response = await axios.post('content-campaigns/options', {
          kind: 'campaigns', locale: this.lang, search: this.search.trim(), page: 1, limit: 50,
        }, { timeout: 10000 })
        if (sequence !== this.sequence) return
        if (!response.data || !Array.isArray(response.data.items)) throw new Error('INVALID_OPTIONS')
        this.options = response.data.items.filter(item => item && typeof item.id === 'string' && typeof item.title === 'string')
      } catch (error) { if (sequence === this.sequence) this.message = this.words[errorKey(error)] } finally { if (sequence === this.sequence) this.loading = false }
    },
  },
}
</script>
